import { extendTheme, withDefaultColorScheme } from "@chakra-ui/react";

import { BUTTON_STYLES } from "./styles/button-styles";
import { HEADING_STYLES } from "./styles/heading-styles";
import { menuTheme } from "./styles/menu";

export const broTheme = extendTheme(withDefaultColorScheme({ colorScheme: "blue" }), {
  styles: {},
  fonts: {
    heading: `'Inconsolata', sans-serif`,
  },
  fontWeights: {},
  sizes: {
    input: "2.5rem",
    button: "40px",
    sideBarClosed: {
      width: "10",
      height: "100vh",
    },
  },
  colors: {
    softBg: "#FAFAFAD9",
    primary: "#F29C1F",
    primaryBg: "linear-gradient(to bottom, #F29C1F, #DA5D2F)",
    accent: "#8DAC82",
    accentLight: "#E8EEE6",
    text: "#181819",
  },
  radii: {
    base: "4px",
    large: "10px",
  },
  components: {
    Heading: HEADING_STYLES,
    Button: BUTTON_STYLES,
    Menu: menuTheme,
    Text: {
      defaultProps: {
        fontWeight: "700",
        color: "text",
      },
    },
  },
});
